//文字コードはutf-8

/* リンクのテキストをホバースライド構造でラップする（マークアップは素のまま）
 * ホバーで元テキストが上へ抜け、複製が下から入れ替わる
 * 参考: ma-ve.co.jp のヘッダーリンク
========================================================*/
export function initHoverSlide() {
    document.querySelectorAll('.jsLink').forEach(wrapLink);
}

function wrapLink(el) {
    if (el.dataset.hoverReady) return; // 二重適用防止
    el.dataset.hoverReady = '1';

    // 子要素（チェブロンやラベルのwrapper span等）の構造は残し、
    // 配下のテキストノードだけをラップする（直下だけでなく孫要素内も対象）
    const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
    const textNodes = [];
    let node;
    while ((node = walker.nextNode())) {
        if (node.textContent.trim()) textNodes.push(node);
    }

    textNodes.forEach((textNode) => {
        const text = textNode.textContent.trim();
        const outer = document.createElement('span');
        outer.className = 'modHoverSlide';
        const inner = document.createElement('span');
        inner.className = 'modHoverSlide__in';
        inner.dataset.text = text;
        inner.textContent = text;
        outer.appendChild(inner);
        textNode.replaceWith(outer);
    });
}
